// used for test mocking
export function reloadPage() {
  window.location.reload()
}
